// Kopplar varje kommun till sitt län (länsstyrelse) och till de nationella
// regelverk som styr kommunala och lokala föreskrifter. Källorna är
// officiella: länsstyrelsernas webbplatser och riksdagen.se.

import { getCityName } from "@/lib/city-coords";
import { rd } from "@/lib/laws-links";

export interface Lan {
  slug: string;
  label: string;
  /** Länsstyrelsens officiella webbplats. */
  url: string;
}

export const LAN: Lan[] = [
  { slug: "stockholm", label: "Stockholms län", url: "https://www.lansstyrelsen.se/stockholm.html" },
  { slug: "uppsala", label: "Uppsala län", url: "https://www.lansstyrelsen.se/uppsala.html" },
  { slug: "sodermanland", label: "Södermanlands län", url: "https://www.lansstyrelsen.se/sodermanland.html" },
  { slug: "ostergotland", label: "Östergötlands län", url: "https://www.lansstyrelsen.se/ostergotland.html" },
  { slug: "jonkoping", label: "Jönköpings län", url: "https://www.lansstyrelsen.se/jonkoping.html" },
  { slug: "kronoberg", label: "Kronobergs län", url: "https://www.lansstyrelsen.se/kronoberg.html" },
  { slug: "kalmar", label: "Kalmar län", url: "https://www.lansstyrelsen.se/kalmar.html" },
  { slug: "gotland", label: "Gotlands län", url: "https://www.lansstyrelsen.se/gotland.html" },
  { slug: "blekinge", label: "Blekinge län", url: "https://www.lansstyrelsen.se/blekinge.html" },
  { slug: "skane", label: "Skåne län", url: "https://www.lansstyrelsen.se/skane.html" },
  { slug: "halland", label: "Hallands län", url: "https://www.lansstyrelsen.se/halland.html" },
  { slug: "vastra-gotaland", label: "Västra Götalands län", url: "https://www.lansstyrelsen.se/vastra-gotaland.html" },
  { slug: "varmland", label: "Värmlands län", url: "https://www.lansstyrelsen.se/varmland.html" },
  { slug: "orebro", label: "Örebro län", url: "https://www.lansstyrelsen.se/orebro.html" },
  { slug: "vastmanland", label: "Västmanlands län", url: "https://www.lansstyrelsen.se/vastmanland.html" },
  { slug: "dalarna", label: "Dalarnas län", url: "https://www.lansstyrelsen.se/dalarna.html" },
  { slug: "gavleborg", label: "Gävleborgs län", url: "https://www.lansstyrelsen.se/gavleborg.html" },
  { slug: "vasternorrland", label: "Västernorrlands län", url: "https://www.lansstyrelsen.se/vasternorrland.html" },
  { slug: "jamtland", label: "Jämtlands län", url: "https://www.lansstyrelsen.se/jamtland.html" },
  { slug: "vasterbotten", label: "Västerbottens län", url: "https://www.lansstyrelsen.se/vasterbotten.html" },
  { slug: "norrbotten", label: "Norrbottens län", url: "https://www.lansstyrelsen.se/norrbotten.html" },
];

export const LAN_KOMMUNER: Record<string, string[]> = {
  stockholm: ["botkyrka","danderyd","ekero","haninge","huddinge","jarfalla","lidingo","nacka","norrtalje","nykvarn","nynashamn","salem","sigtuna","sollentuna","solna","stockholm","sundbyberg","sodertalje","taby","tyreso","upplands-bro","upplands-vasby","vallentuna","vaxholm","varmdo","osteraker"],
  uppsala: ["alvkarleby","enkoping","heby","habo","knivsta","tierp","uppsala","osthammar"],
  sodermanland: ["eskilstuna","flen","gnesta","katrineholm","nykoping","oxelosund","strangnas","trosa","vingaker"],
  ostergotland: ["boxholm","finspang","kinda","linkoping","mjolby","motala","norrkoping","soderkoping","vadstena","valdemarsvik","ydre","atvidaberg","odeshog"],
  jonkoping: ["aneby","eksjo","gislaved","gnosjo","jonkoping","mullsjo","nassjo","savsjo","tranas","vaggeryd","vetlanda","varnamo"],
  kronoberg: ["alvesta","lessebo","ljungby","markaryd","tingsryd","uppvidinge","vaxjo","almhult"],
  kalmar: ["borgholm","emmaboda","hogsby","hultsfred","kalmar","monsteras","morbylanga","nybro","oskarshamn","torsas","vimmerby","vastervik"],
  gotland: ["gotland"],
  blekinge: ["karlshamn","karlskrona","olofstrom","ronneby","solvesborg"],
  skane: ["bjuv","bromolla","burlov","bastad","eslov","helsingborg","hassleholm","hoganas","horby","hoor","klippan","kristianstad","kavlinge","landskrona","lomma","lund","malmo","osby","perstorp","simrishamn","sjobo","skurup","staffanstorp","svalov","svedala","tomelilla","trelleborg","vellinge","ystad","angelholm","astorp","orkelljunga","ostra-goinge"],
  halland: ["falkenberg","halmstad","hylte","kungsbacka","laholm","varberg"],
  "vastra-gotaland": ["ale","alingsas","bengtsfors","bollebygd","boras","dals-ed","essunga","falkoping","fargelanda","grastorp","gullspang","goteborg","gotene","herrljunga","hjo","harryda","karlsborg","kungalv","lerum","lidkoping","lilla-edet","lysekil","mariestad","mark","mellerud","munkedal","molndal","orust","partille","skara","skovde","sotenas","stenungsund","stromstad","svenljunga","tanum","tibro","tidaholm","tjorn","toreboda","trollhattan","tranemo","uddevalla","ulricehamn","vara","vargarda","vanersborg","amal","ockero"],
  varmland: ["arvika","eda","filipstad","forshaga","grums","hagfors","hammaro","karlstad","kil","kristinehamn","munkfors","storfors","sunne","saffle","torsby","arjang"],
  orebro: ["askersund","degerfors","hallsberg","hallefors","karlskoga","kumla","laxa","lekeberg","lindesberg","ljusnarsberg","nora","orebro"],
  vastmanland: ["arboga","fagersta","hallstahammar","koping","kungsor","norberg","sala","skinnskatteberg","surahammar","vasteras"],
  dalarna: ["avesta","borlange","falun","gagnef","hedemora","leksand","ludvika","malung-salen","mora","orsa","rattvik","smedjebacken","sater","vansbro","alvdalen"],
  gavleborg: ["bollnas","gavle","hofors","hudiksvall","ljusdal","nordanstig","ockelbo","ovanaker","sandviken","soderhamn"],
  vasternorrland: ["harnosand","kramfors","solleftea","sundsvall","timra","ange","ornskoldsvik"],
  jamtland: ["berg","bracke","harjedalen","krokom","ragunda","stromsund","are","ostersund"],
  vasterbotten: ["bjurholm","dorotea","lycksele","mala","nordmaling","norsjo","robertsfors","skelleftea","sorsele","storuman","umea","vilhelmina","vindeln","vannas","asele"],
  norrbotten: ["arjeplog","arvidsjaur","boden","gallivare","haparanda","jokkmokk","kalix","kiruna","lulea","pajala","pitea","alvsbyn","overkalix","overtornea"],
};

const KOMMUN_TO_LAN: Record<string, string> = (() => {
  const map: Record<string, string> = {};
  for (const [lan, kommuner] of Object.entries(LAN_KOMMUNER)) {
    for (const k of kommuner) map[k] = lan;
  }
  return map;
})();

export function lanForCity(citySlug: string): Lan | undefined {
  const lanSlug = KOMMUN_TO_LAN[citySlug];
  return lanSlug ? LAN.find((l) => l.slug === lanSlug) : undefined;
}

export function citiesInLan(lanSlug: string): string[] {
  return LAN_KOMMUNER[lanSlug] ?? [];
}

export function allMappedCitySlugs(): string[] {
  return Object.keys(KOMMUN_TO_LAN).sort();
}

export interface LocalRuleSource {
  title: string;
  short: string;
  url: string;
  /** Vem som beslutar regeln. */
  level: "Riksdagen" | "Regeringen" | "Länsstyrelsen" | "Kommunen";
}

/**
 * De nationella författningar som ger kommunen rätt att besluta lokala
 * föreskrifter. Samma för alla kommuner – det som skiljer är kommunens
 * egna beslut.
 */
export const KOMMUN_LEGAL_BASE: LocalRuleSource[] = [
  { title: "Kommunallagen (2017:725)", short: "Kommunens befogenheter, kommunfullmäktige, laglighetsprövning och den kommunala självstyrelsen.", url: rd("2017:725"), level: "Riksdagen" },
  { title: "Ordningslagen (1993:1617)", short: "Grunden för lokala ordningsföreskrifter – allmänna platser, alkohol, fyrverkerier och offentliga tillställningar.", url: rd("1993:1617"), level: "Riksdagen" },
  { title: "Miljöbalken (1998:808)", short: "Ger kommunen rätt att besluta lokala miljö- och hälsoskyddsföreskrifter samt strandskyddsdispenser.", url: rd("1998:808"), level: "Riksdagen" },
  { title: "Plan- och bygglagen (2010:900)", short: "Detaljplaner, bygglov och områdesbestämmelser beslutas av kommunen enligt PBL.", url: rd("2010:900"), level: "Riksdagen" },
  { title: "Trafikförordningen (1998:1276)", short: "Kommunen beslutar lokala trafikföreskrifter (LTF) – hastighet, parkering och förbudszoner.", url: rd("1998:1276"), level: "Regeringen" },
  { title: "Avfallsförordningen (2020:614)", short: "Kommunens renhållningsordning och avfallsföreskrifter bygger på denna förordning.", url: rd("2020:614"), level: "Regeringen" },
  { title: "Lag om skydd mot olyckor (2003:778)", short: "Kommunens handlingsprogram för räddningstjänst och eldningsförbud.", url: rd("2003:778"), level: "Riksdagen" },
  { title: "Alkohollagen (2010:1622)", short: "Serveringstillstånd och tillsyn beslutas av kommunen.", url: rd("2010:1622"), level: "Riksdagen" },
];

/** Riksdagens sökning efter lokala trafikföreskrifter m.m. för en kommun. */
export function localRuleSearchUrl(citySlug: string, query: string): string {
  const name = getCityName(citySlug);
  return `https://www.bing.com/search?q=${encodeURIComponent(`${query} ${name} kommun`)}`;
}

export function stfsUrl(): string {
  return "https://rdt.transportstyrelsen.se/rdt/AF06_View.aspx";
}
